import { Link } from "react-router-dom";
// import { useEffect, useState } from "react";
// import axios from "axios";


const Gstmain = () => {

  // const [userIncome, setUserIncome] = useState([]);

  // const getUserIncome = async () => {
  //   try {
  //     const response = await axios.get(
  //       "https://apimlm.bloomitsolutions.in/auth/getAllAdminIncomes"
  //     );
  //     setUserIncome(response.data);
  //   } catch (error) {
  //     console.error("Error fetching data: ", error);
  //   }
  // };


  // useEffect(() => {
  //   getUserIncome();
  // }, []);


  return (
    <section>
      <div className="container-fluid">
        <div className="row">
          

          <div className="col-lg-10 mt-3 mb-3">
            <div className="row">
              <div className="col-lg-1 text-end">
                <Link to="/">
                  <h6>
                    <i class="fa fa-home" aria-hidden="true"></i>Home
                  </h6>
                </Link>
              </div>
              /
              <div className="col-lg-5">
                <h6>GST Charges Details</h6>
              </div>
            </div>

            <div className="row">
              <div className="card border-0 shadow ">
                <div className="card-header bg bg-info border-0">
                  <h4>GST Charges Details</h4>
                </div>

                <div className="card-body text-center">
                  <div className="col-lg-10 ">
                    <div className="row ">
                      {/* =======================basic start================= */}

                      <div className="col-lg-4 border border-0 rounded-3 mt-3">
                        <div className="card bg bg-warning">
                          <div className="card-body">
                            <h5 className="mt-2">GST Charges</h5>
                            <h2 className="mt-2">
                              <i className="fa fa-eye" aria-hidden="true"></i>
                              9,567
                            </h2>

                            <Link
                              to=""
                              className="btn btn-danger btn-sm mt-2 mb-2"
                            >
                              Click here
                            </Link>
                          </div>
                        </div>
                      </div>

                      {/* =======================basic end================= */}

                      {/* ====================Premium start==================== */}

                      {/* <div className="col-lg-4 border border-0 rounded-3 mt-3">
                        <div className="card bg bg-warning">
                          <div className="card-body">
                            <h5 className="mt-2">TDS Charges</h5>
                            <h2 className="mt-2">
                              <i className="fa fa-eye" aria-hidden="true"></i>
                              {userIncome.totalTDS}
                            </h2>

                            <Link
                              to=""
                              className="btn btn-danger btn-sm mt-2 mb-2"
                            >
                              Click here
                            </Link>
                          </div>
                        </div>
                      </div> */}

                      {/* ====================Premium end==================== */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gstmain;
